<template>
    <div v-if="ready">
        <div class="mb-4">
            <!-- Set an empty active class, so we don't get an 'active' go back to overview button -->
            <router-link
                class="btn btn-brand"
                :to="{ name: 'admin.faq.index' }"
                active-class=""
            >
                <i class="fa fa-arrow-left"></i>
                {{ uLang('app.go_to_overview') }}
            </router-link>
        </div>
        
        <form
            class="form-horizontal fr-absolute"
            @submit.prevent="store"
            @keydown="form.errors.clear($event.target.name)"
            novalidate
            autocomplete="off"
        >
            <form-input
                :form="form"
                v-if="$can('create-faq')"
                name="question"
            />
            
            <ckeditor
                v-if="$can('create-faq')"
                name="answer"
                v-model="form.answer"
                :error="form.errors.get('answer')"
            />
            
            <div class="form-group fr-absolute">
                <input :disabled="form.busy" type="submit" class="btn btn-brand" :value="uLang('app.save')"/>
            </div>
        </form>
    </div>
</template>

<script>
    import Form from '~/Form/Form';
    import FormMixin from '~/mixins/form';
    import { SuccessfullyStoredAlert, SuccessfullyUpdatedAlert } from "~/Swals";
    import Ckeditor from "~/components/elements/ckeditor";

    export default {
        name: 'form-admin-faq',
        mixins: [ FormMixin ],

        props: {
            id: {
                required: false,
            }
        },
        created () {
            this.$on('afterStore', this.afterStore);
            this.$on('afterUpdate', this.afterUpdate)
        },
        components: {
            'ckeditor': Ckeditor,
        },
        data() {
            return {
                entity: 'faq',
                form: new Form({
                    question: '',
                    answer: '',
                }),
                swal: false,
            };
        },
        computed: {
        
        },
        methods: {
            afterStore(data) {
                new SuccessfullyStoredAlert({
                    entity: this.lang('app.question')
                })
                    .show()
                    .then((buttonPressed) => {
                        if (buttonPressed === 'show') {
                            this.$router.push({
                                name: 'admin.faq.view',
                                params: {
                                    id: data.id,
                                }
                            });
                        }
                    });
            },
            afterUpdate() {
                new SuccessfullyUpdatedAlert({
                    entity: this.lang('app.question')
                })
                    .show()
                    .then(() => {
                        this.$router.push({ name: 'admin.faq.index' });
                    });
            }
        }
    };
</script>

<style lang="css">

</style>
